
import { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';


function WarningIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.5L22 20.5H2L12 2.5Z" fill="#D7A31A" stroke="#D7A31A" strokeWidth="1.5" strokeLinejoin="round" />
      <rect x="11.1" y="9" width="1.8" height="6" rx="0.9" fill="#1a1200" />
      <rect x="11.1" y="16.5" width="1.8" height="1.8" rx="0.9" fill="#1a1200" />
    </svg>
  );
}


function fmtDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric'
    });
  } catch {
    return iso;
  }
}


function overdueDays(dateStr) {
  if (!dateStr) return null;
  const diff = Math.round((new Date(dateStr) - Date.now()) / 86_400_000);
  return diff < 0 ? Math.abs(diff) : null;
}


function PaymentModal({ onDismiss, dueDate }) {
  const { t } = useTranslation();

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onDismiss(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onDismiss]);

  const days = overdueDays(dueDate);
  const contactEmail = 'billing@forthcode.com';

  return (
    <div
      className="pw-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onDismiss(); }}
    >
      <div className="pw-modal-wrapper">
        <div className="pw-modal" role="dialog" aria-modal="true" aria-labelledby="pw-modal-title">

          <div className="pw-modal__header">
            <div className="pw-modal__header-icon">
              <WarningIcon size={28} />
            </div>
            <div className="pw-modal__header-text">
              <h2 className="pw-modal__title" id="pw-modal-title">
                {t('topHeader.nonPaymentModal.modalTitle')}
              </h2>
              <p className="pw-modal__subtitle">
                {t('topHeader.nonPaymentModal.modalSubtitle')}
              </p>
            </div>
          </div>

          <div className="pw-modal__body">
            <p className="pw-modal__desc">
              <Trans i18nKey="topHeader.nonPaymentModal.modalDesc" components={{ 1: <strong /> }} />
            </p>

            {dueDate && (
              <div className="pw-invoice">
                <div className="pw-invoice__row">
                  <span className="pw-invoice__label">Due Date</span>
                  <span className={`pw-invoice__value${days ? ' pw-invoice__value--overdue' : ''}`}>
                    {fmtDate(dueDate)}
                    {days && (
                      <span className="pw-invoice__overdue-badge">
                        · Overdue by {days} day{days !== 1 ? 's' : ''}
                      </span>
                    )}
                  </span>
                </div>
              </div>
            )}

            <p className="pw-modal__contact">
              {t('topHeader.nonPaymentModal.contactNote')}{' '}
              <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
            </p>
          </div>

          <div className="pw-modal__footer">
            <button className="pw-modal__dismiss-btn" onClick={onDismiss}>
              {t('topHeader.nonPaymentModal.dismiss')}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}


export function PaymentWarningUI({ warning, dueDate, dismissWarning, isDismissed }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  if (!warning || isDismissed) return null;
  return (
    <>
      <div className="pw-banner" role="alert">
        <div className="pw-banner__left">
          <WarningIcon size={20} />
          <span className="pw-banner__text">
            <strong>{t('topHeader.nonPaymentModal.warningTitle')}</strong> — {warning}
          </span>
        </div>
        <div className="pw-banner__actions">
          <button className="pw-banner__view-btn" onClick={() =>{
            dismissWarning();
            setShowModal(false);
          }}>
            {t('topHeader.nonPaymentModal.dismiss')}
          </button>
        </div>
      </div>

      {showModal && (
        <PaymentModal
          onDismiss={() => {
            dismissWarning();
            setShowModal(false);
          }}
          dueDate={dueDate}
        />
      )}
    </>
  );
}
